// extracted by mini-css-extract-plugin
export default {"WrapShareButton":"SAnLMKeDgPpUQOwRoCsr","halfWidth":"i9AO9rwgbdVoP2TdLZxC","fullWidth":"PFVBzEoAW7aeaTg8RGQI"};